const routes = [
  {
    path: '/smartPlatform',
    name: 'smartPlatform',
    component: () => import('./pages/Home'),
    // redirect: '/carAccessRecord/index',
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'coldStorageManage', // 冷库管理
        name: 'coldStorageManage',
        component: () => import('./pages/ColdStorageManage'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'platformManage', // 月台管理
        name: 'platformManage',
        component: () => import('./pages/PlatformManage'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
    ]
  }
]

export default routes